module.exports = __webpack_public_path__ + "static/img/routing_created.35a8c04f.svg";